var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{attrs:{"value":_vm.lastValue,"placeholder":_vm.placeholder},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }